import { FC } from 'react';
import { Typography } from 'shared/ui/typography';
import { BasicCard } from '../basicCard';
import { TagContainer } from './styles';
import { SmallCloseIconButton } from 'shared/ui/buttons/iconButtons/smallCloseButton';
import { TagCardProps } from './types';

export const TagCard: FC<TagCardProps> = ({
	name,
	border,
	bg,
	outputCloseButton = true,
	outputCloseButtonVariant,
	onClick,
	typographyProps,
	variant,
	padding,
	className,
}) => {
	return (
		<BasicCard
			fitContent={true}
			styles={{ border, borderRadius: '50px' }}
			variant={variant}
			isRoundedCorners={true}
			className={className}
      bg={bg}
		>
			<TagContainer $variant={variant} style={{ padding }} $bg={bg}>
				<Typography colorVariant={'inherit'} {...typographyProps}>
					{name}
				</Typography>
				{outputCloseButton && (
					<SmallCloseIconButton
						onClick={onClick}
						variant={outputCloseButtonVariant}
					/>
				)}
			</TagContainer>
		</BasicCard>
	);
};
